import React from 'react';
import './StopMedia.scss';

const StopMediaHTML = props => {
  const { name, description } = props;
  return (
    <div id="html-wrapper">
      <div id="htmlElement">
        <h3>{name}</h3>
        <p dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

export default StopMediaHTML;
